<template>
    <div class="container tab-panel p-3">
        <div class="mb-3">
            <label for="reportSelect" class="form-label">Rapportmall</label>
            <select id="reportSelect" class="form-select" v-model="reportId" @change="onChangeReport">
                <option v-for="report in reports" :value="report.id">{{ report.name }}</option>
            </select>
        </div>
        <div v-show="reportId" class="alert alert-info">
            {{ report?.description }}
        </div>
        <div class="row">
            <div class="col-3" v-show="report?.fields.includes('date')">
                <label for="dateInput" class="form-label">Datum</label>
                <input id="dateInput" type="date" class="form-control" v-model="date">
            </div>
            <div class="col-3" v-show="report?.fields.includes('time')">
                <label for="timeInput" class="form-label">Tid</label>
                <input id="timeInput" type="time" class="form-control" v-model="time">
            </div>
            <div class="col-3" v-show="report?.fields.includes('start')">
                <label for="dateInput" class="form-label">Startdatum</label>
                <input id="dateInput" type="date" class="form-control" v-model="start">
            </div>
            <div class="col-3" v-show="report?.fields.includes('stop')">
                <label for="dateInput" class="form-label">Stoppdatum</label>
                <input id="dateInput" type="date" class="form-control" v-model="stop">
            </div>
        </div>
        <div class="mt-3">
            <button class="btn btn-primary" @click="onGenerateReport" :disabled="!reportId">Generera rapport</button>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import sitesService from '@/services/sitesService'
import writeXlsxFile from 'write-excel-file'

const now = new Date()

const route = useRoute()
const reportId = ref(null)
const report = ref(null)
const date = ref(new Date().toLocaleDateString('sv'))
const time = ref('00:00')
const start = ref(new Date(now.getFullYear(), now.getMonth() - 1, 1).toLocaleDateString('sv'))
const stop = ref(new Date(now.getFullYear(), now.getMonth(), 0).toLocaleDateString('sv'))
const reports = ref([])

const onChangeReport = () => {
    report.value = reports.value.find(r => r.id === reportId.value)
}

const onGenerateReport = () => {
    if (!report.value) return

    const params = {}
    if (report.value.fields.includes('start')) {
        if (start.value.length === 10) {
            params.start = new Date(start.value + 'T00:00')
        } else {
            params.start = new Date(start.value)
        }
    }
    if (report.value.fields.includes('stop')) {
        if (stop.value.length === 10) {
            params.stop = new Date(stop.value + 'T00:00')
        } else {
            params.stop = new Date(stop.value)
        }
        params.stop = new Date(params.stop.getFullYear(), params.stop.getMonth(), params.stop.getDate() + 1)
    }
    if (report.value.fields.includes('date') && report.value.fields.includes('time')) {
        params.timestamp = new Date(date.value + 'T' + time.value)
    } else if (report.value.fields.includes('date')) {
        params.date = new Date(date.value)
    } else if (report.value.fields.includes('time')) {
        params.time = new Date(date.value)
    }

    sitesService.getReport(route.params.id, report.value.id, params).then(result => {
        const schema = []
        for (const sheet of result.data.schema) {
            const sheetSchema = []
            for (const s of sheet) {
                const column = {
                    column: s.column,
                    width: s.width,
                    header: { backgroundColor: '#ffff00' }
                }
                switch (s.type) {
                    case 'Number':
                        column.type = Number
                        column.value = data => (data[s.property] == null || isNaN(data[s.property])) ? null : Number(data[s.property])
                        break
                    default:
                        column.type = String
                        column.value = data => String(data[s.property] ?? '')
                        break
                }
                sheetSchema.push(column)
            }
            schema.push(sheetSchema)
        }

        writeXlsxFile(result.data.rows, {
            schema,
            sheets: result.data.sheets,
            headerStyle: {
                backgroundColor: '#cccccc',
                fontSize: 10,
                align: 'left'
            }, 
            fileName: result.data.fileName ?? `${report.value.name}_${date.value}_${time.value.replace(':', '_')}.xlsx`
        })
    })
}

onMounted(async () => {
    reports.value = (await sitesService.getReports(route.params.id)).data
})
</script>